<template>
  <div class="container page">
    <van-nav-bar :title="$t('kefu.title')" class="custom-navbar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="iframe_page">
      <iframe width="100%" height="100%" frameborder="0" id="iframe_web" :src="this.$store.getters.getBaseInfo.kefu !==undefined ?this.$store.getters.getBaseInfo.kefu:'https://hao.360.com/'" ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    back(){
      return window.history.back();
    }
  },
  created() {

  },
  mounted(){
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById('iframe_web');
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = (Number(deviceHeight)-65) + 'px'; //数字是页面布局高度差
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.custom-navbar {
  z-index: 999;
  position: relative;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
  
  ::v-deep .van-nav-bar__content {
    background: transparent;
  }
  
  ::v-deep .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 20px;
  }
  
  ::v-deep .van-icon {
    color: #fff;
    font-size: 20px;
  }
}

.iframe_page {
  width: 100%;
  height: calc(100vh - 65px);
}

#iframe_web {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .custom-navbar {
    ::v-deep .van-nav-bar__title {
      font-size: 18px;
    }
    
    ::v-deep .van-icon {
      font-size: 20px;
    }
  }
}
</style>
